import React from 'react';
import Grid3X3 from 'lucide-react/dist/esm/icons/grid-3x3.js';

/**
 * SquareGridCard - Wrapper component for Standard-style square grid display
 * 
 * Provides the card wrapper, "SQUARES AVAILABLE" header, and progress bar
 * that appears in the Standard layout. Used to ensure consistent presentation
 * across different pages (Standard home, PYS, etc).
 * 
 * @param {React.ReactNode} children - The SquareGrid component or other content to render
 * @param {number} available - Number of available squares
 * @param {number} total - Total number of squares
 * @param {string} className - Optional additional classes for the card wrapper
 */
export default function SquareGridCard({ children, available, total, className = '' }) {
  const percentage = total > 0 ? (available / total) * 100 : 0;

  return (
    <div className={`bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700 shadow-sm ${className}`}>
      {/* Header: "SQUARES AVAILABLE" + count */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
          <Grid3X3 className="w-4 h-4" />
          Squares Available
        </div>
        <div className="text-lg font-bold text-gray-900 dark:text-white">
          {available} of {total}
        </div>
      </div>

      {/* Progress Bar */}
      <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2 mb-6">
        <div 
          className="bg-green-500 h-2 rounded-full transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>

      {/* Grid content (passed as children) */}
      {children}
    </div>
  );
}
